<template>
    <div>
        <template v-for="item in pageData?.children" :key="item.modelKey">
            <RenderFragment :template="item" />
        </template>
    </div>
</template>

<script setup lang="ts">
import { PropType, ref } from 'vue';
import RenderFragment from './components/render-fragment.vue';

const props = defineProps({
    type: {
        type: String as PropType<'home'>,
        default: '',
    },
});

const pageData = ref<any>();

async function initPage() {
    if (props.type) {
        try {
            const res = await G_transmit('GetPageConfig', { queries: { type: props.type } });
            pageData.value = JSON.parse(res.data?.config ?? '{}');
        } catch (error) {
            console.error(error);
        }
    }
}

initPage();
</script>
